module.exports = __webpack_public_path__ + "static/G1N2-b1574ba1483ab1208d39c5cc990c6771.jpg";